/**
 * zona-engrase-helpers.ts — pure helpers for managing the zonas array in IsEngrase.
 *
 * All functions return new arrays without mutating their inputs.
 */
import type { ZonaEngrase } from "../../types.js";
import type { TablaGenerica } from "../../types.js";

export function addZona(zonas: ZonaEngrase[], zona: ZonaEngrase): ZonaEngrase[] {
  return [...zonas, zona];
}

export function removeZona(zonas: ZonaEngrase[], idx: number): ZonaEngrase[] {
  if (idx < 0 || idx >= zonas.length) return zonas;
  return zonas.filter((_, i) => i !== idx);
}

export function setZonaTitulo(zonas: ZonaEngrase[], idx: number, titulo: string): ZonaEngrase[] {
  if (idx < 0 || idx >= zonas.length) return zonas;
  return zonas.map((z, i) => (i === idx ? { ...z, titulo } : z));
}

export function setZonaDescripcion(
  zonas: ZonaEngrase[],
  idx: number,
  descripcion: string,
): ZonaEngrase[] {
  if (idx < 0 || idx >= zonas.length) return zonas;
  return zonas.map((z, i) => (i === idx ? { ...z, descripcion } : z));
}

export function setZonaTabla(
  zonas: ZonaEngrase[],
  idx: number,
  tabla: TablaGenerica,
): ZonaEngrase[] {
  if (idx < 0 || idx >= zonas.length) return zonas;
  return zonas.map((z, i) => (i === idx ? { ...z, tabla } : z));
}
